/*
 * @Author: wanxiaodong
 * @Date: 2020-01-14 17:15:18
 * @Last Modified by: wanxiaodong
 * @Last Modified time: 2020-01-14 17:59:15
 * @Description: 防篡改水印组件 - 随机渲染并检测变化
 */
import React, { Component } from 'react'
import './watermark.less'

export default class WaterMark extends Component<{}> {
    private containerRef: React.RefObject<HTMLDivElement>
    private observer: MutationObserver | null = null
    private checkInterval: number | null = null
    private isRegenerating: boolean = false
    private watermarkCount: number = 20

    constructor(props: {}) {
        super(props)
        this.containerRef = React.createRef()
    }

    componentDidMount(): void {
        this.generateWatermarks()
        this.startIntegrityCheck()
        setTimeout(() => {
            this.setupMutationObserver()
        }, 1000)
    }

    componentWillUnmount(): void {
        if (this.observer) {
            this.observer.disconnect()
        }
        if (this.checkInterval) {
            window.clearInterval(this.checkInterval)
        }
    }

    private generateWatermarks(): void {
        const container = this.containerRef.current
        if (!container) return

        container.innerHTML = ''

        for (let i = 0; i < this.watermarkCount; i++) {
            const watermark = document.createElement('div')
            watermark.className = 'water-mark-item'
            watermark.textContent = 'by wanxiaodong'
            watermark.style.cssText = `
                position: absolute;
                left: ${Math.random() * 100}%;
                top: ${Math.random() * 100}%;
                transform: rotate(${Math.random() * 60 - 30}deg);
                font-size: ${14 + Math.random() * 8}px;
            `

            watermark.setAttribute('data-watermark', 'true')
            container.appendChild(watermark)
        }
    }

    private regenerateWatermarks(): void {
        if (this.isRegenerating) return

        this.isRegenerating = true

        if (this.observer) {
            this.observer.disconnect()
        }

        setTimeout(() => {
            this.generateWatermarks()
            console.warn('检测到水印被篡改，已重新生成水印')
            this.isRegenerating = false

            setTimeout(() => {
                this.setupMutationObserver()
            }, 500)
        }, 100)
    }

    private setupMutationObserver(): void {
        if (this.isRegenerating) return
        const container = this.containerRef.current
        if (!container) return

        if (this.observer) {
            this.observer.disconnect()
        }

        this.observer = new MutationObserver((mutations: MutationRecord[]) => {
            if (this.isRegenerating) return

            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    const watermarks = container.querySelectorAll('.water-mark-item')
                    if (watermarks.length !== this.watermarkCount) {
                        this.regenerateWatermarks()
                        return
                    }
                } else if (mutation.type === 'attributes') {
                    const target = mutation.target as HTMLElement
                    if (target.classList.contains('water-mark-item')) {
                        if (mutation.attributeName === 'style' ||
                            mutation.attributeName === 'class' ||
                            mutation.attributeName === 'contenteditable') {
                            this.regenerateWatermarks()
                            return
                        }
                    }
                }
            }
        })

        this.observer.observe(container, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'contenteditable']
        })
    }

    private startIntegrityCheck(): void {
        this.checkInterval = window.setInterval(() => {
            if (this.isRegenerating) return

            const container = this.containerRef.current
            if (!container) return

            const watermarks = container.querySelectorAll('.water-mark-item')

            if (watermarks.length !== this.watermarkCount) {
                this.regenerateWatermarks()
                return
            }

            for (const watermark of Array.from(watermarks)) {
                const htmlElement = watermark as HTMLElement
                const computedStyle = window.getComputedStyle(htmlElement)

                if (computedStyle.display === 'none' ||
                    computedStyle.visibility === 'hidden' ||
                    computedStyle.opacity === '0' ||
                    parseFloat(computedStyle.opacity) < 0.3) {
                    this.regenerateWatermarks()
                    return
                }

                if (htmlElement.getAttribute('contenteditable') === 'true') {
                    this.regenerateWatermarks()
                    return
                }
            }
        }, 3000)
    }

    render() {
        return (
            <div
                ref={this.containerRef}
                className="water-mark-container"
                onContextMenu={(e) => e.preventDefault()}
            />
        )
    }
}